import React from "react";

import { TextField, Typography, Grid } from "@mui/material";

import { BlockStandard } from "components/admin/BlockStandard";
import { PhotoUploadGrid } from "components/forms/PhotoUploadGrid";

export type InverterDetailsItem = {
  solar_inverter_quantity: string;
  solar_inverter_unit_power: string;
  solar_inverter_total_power: string;
  solar_inverter_pictures: File[];
};

export const emptyInverterDetails: InverterDetailsItem = {
  solar_inverter_quantity: "",
  solar_inverter_unit_power: "",
  solar_inverter_total_power: "",
  solar_inverter_pictures: [],
};

type InverterDetailsProps = {
  inverterData: InverterDetailsItem;
  onChange: (updated: InverterDetailsItem) => void;
};

export const InverterDetails = ({
  inverterData,
  onChange,
}: InverterDetailsProps) => {
  const handleQuantityChange = ({ target: { value } }) => {
    onChange({
      ...inverterData,
      solar_inverter_quantity: value,
    });
  };

  const handleUnitPowerChange = ({ target: { value } }) => {
    onChange({
      ...inverterData,
      solar_inverter_unit_power: value,
    });
  };

  const handleTotalPowerChange = ({ target: { value } }) => {
    onChange({
      ...inverterData,
      solar_inverter_total_power: value,
    });
  };

  const handlePhotosChange = (photos: File[]) => {
    onChange({
      ...inverterData,
      solar_inverter_pictures: photos,
    });
  };

  return (
    <BlockStandard hideDivider>
      <Typography variant="subtitle1">Inversores</Typography>

      <Grid container direction="row" gap={0.5} justifyContent="space-between">
        <TextField
          label="Quantidade"
          placeholder="Ex. 1"
          variant="outlined"
          fullWidth
          value={inverterData.solar_inverter_quantity}
          onChange={handleQuantityChange}
          sx={{ flex: 1 }}
        />

        <TextField
          label="Pot. Unitária (W)"
          placeholder="Ex.: 18W"
          variant="outlined"
          fullWidth
          value={inverterData.solar_inverter_unit_power}
          onChange={handleUnitPowerChange}
          sx={{ flex: 1 }}
        />

        <TextField
          label="Pot. total (W)"
          placeholder="Ex.: 18W"
          variant="outlined"
          fullWidth
          value={inverterData.solar_inverter_total_power}
          onChange={handleTotalPowerChange}
          sx={{ flex: 1 }}
        />
      </Grid>

      <PhotoUploadGrid
        photos={inverterData.solar_inverter_pictures}
        onPhotosChange={handlePhotosChange}
      />
    </BlockStandard>
  );
};
